import { Box, LinearProgress, Theme } from '@mui/material'
import useStyles from '~/common/hooks/useStyles'
import { RecordSkeleton } from '~/components/ui/molecules/skeletons/RecordSkeleton'
import { LoadingSpinner } from '../ui/atoms/loading-spinner/LoadingSpinner'

function getStyles(theme: Theme) {
  return {
    table: {
      color: theme.palette.primary.light,
    },
    tableDetails: {
      color: theme.palette.primary.main,
    },
    documentDetails: {
      color: theme.palette.primary.main,
    },
    activity: {
      zIndex: 999,
      color: theme.palette.primary.main,
    },
    formDialog: {
      container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      },
      spinner: {
        padding: theme.spacing(1.25),
        color: theme.palette.common.doss.gray[9],
      },
    },
    navigation: {
      container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      spinner: {
        color: theme.palette.common.doss.white,
      },
    },
  }
}

interface PlaceholderProps {
  type: PlaceholderType
}

export enum PlaceholderType {
  TABLE = 'TABLE',
  TABLE_DETAILS = 'TABLE_DETAILS',
  RECORD_DETAILS = 'RECORD_DETAILS',
  ACTIVITY = 'ACTIVITY',
  FORM = 'FORM',
  NAVIGATION = 'NAVIGATION',
  FORMULA = 'FORMULA',
  DOCUMENT = 'DOCUMENT',
}

/**
 * Placeholder component for when data is loading
 */
export function Placeholder({ type }: PlaceholderProps) {
  const styles = useStyles(getStyles)
  switch (type) {
    case PlaceholderType.TABLE:
      return <LinearProgress sx={styles.table} />
    case PlaceholderType.RECORD_DETAILS:
      return <RecordSkeleton />
    case PlaceholderType.DOCUMENT:
      return <LinearProgress sx={styles.documentDetails} />
    case PlaceholderType.TABLE_DETAILS:
      return <LinearProgress sx={styles.tableDetails} />
    case PlaceholderType.ACTIVITY:
      return <LinearProgress sx={styles.activity} />
    case PlaceholderType.FORM:
    case PlaceholderType.FORMULA:
    case PlaceholderType.NAVIGATION: {
      return (
        <Box sx={styles.navigation.container}>
          <LoadingSpinner type="navigation" />
        </Box>
      )
    }
  }
}

export default Placeholder
